var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.85 7.84676L16.0117 3.29883V6.64645C16.0117 7.31142 16.5812 7.84676 17.2887 7.84676H20.85Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9687 2.07812H2.98787C2.28045 2.07812 1.71094 2.61347 1.71094 3.27844V25.4329C1.71094 26.0978 2.28045 26.6332 2.98787 26.6332H18.53C19.2374 26.6332 19.8069 26.0978 19.8069 25.4329V6.62606",
    fill: "#E2E2E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1562 1.05078H2.17537C1.46795 1.05078 0.898438 1.58612 0.898438 2.2511V24.4055C0.898438 25.0705 1.46795 25.6058 2.17537 25.6058H17.7175C18.4249 25.6058 18.9944 25.0705 18.9944 24.4055V5.59872",
    fill: "#2A7FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1562 1.05078H2.17537C1.46795 1.05078 0.898438 1.58612 0.898438 2.2511V24.4055C0.898438 25.0705 1.46795 25.6058 2.17537 25.6058H17.7175C18.4249 25.6058 18.9944 25.0705 18.9944 24.4055V5.59872",
    stroke: "#2A7FFF",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0023 5.59872L14.1641 1.05078V4.3984C14.1641 5.06338 14.7336 5.59872 15.441 5.59872H19.0023Z",
    fill: "#A6C5FB",
    stroke: "#A6C5FB",
    strokeWidth: 0.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.47067 8.98638C9.26015 8.98359 9.06433 9.08755 8.95821 9.25848C8.85208 9.4294 8.85208 9.6408 8.95821 9.81172C9.06433 9.98264 9.26015 10.0866 9.47067 10.0838L15.8842 10.0838C16.0948 10.0866 16.2906 9.98265 16.3967 9.81172C16.5028 9.6408 16.5028 9.4294 16.3967 9.25848C16.2906 9.08756 16.0948 8.98359 15.8842 8.98638L9.47067 8.98638ZM4.66627 12.2695C4.45575 12.2667 4.25994 12.3707 4.15382 12.5416C4.04769 12.7125 4.04769 12.9239 4.15382 13.0949C4.25994 13.2658 4.45575 13.3697 4.66627 13.367H15.8866C16.0971 13.3697 16.2929 13.2658 16.3991 13.0949C16.5052 12.9239 16.5052 12.7125 16.3991 12.5416C16.2929 12.3707 16.0971 12.2667 15.8866 12.2695H4.66627ZM4.66627 15.5529C4.45575 15.5501 4.25994 15.6541 4.15382 15.825C4.04769 15.996 4.04769 16.2073 4.15382 16.3783C4.25994 16.5492 4.45575 16.6532 4.66627 16.6504H15.8866C16.0971 16.6532 16.2929 16.5492 16.3991 16.3783C16.5052 16.2073 16.5052 15.996 16.3991 15.825C16.2929 15.6541 16.0971 15.5501 15.8866 15.5529H4.66627ZM4.66627 18.8362C4.45575 18.8334 4.25994 18.9374 4.15382 19.1083C4.04769 19.2792 4.04769 19.4906 4.15382 19.6615C4.25994 19.8325 4.45575 19.9364 4.66627 19.9336H15.8866C16.0971 19.9364 16.2929 19.8325 16.3991 19.6615C16.5052 19.4906 16.5052 19.2792 16.3991 19.1083C16.2929 18.9374 16.0971 18.8334 15.8866 18.8362H4.66627Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocxIcon);
export default __webpack_public_path__ + "static/media/docxIcon.ff4a0e09d41ee7aa576f06a333b1e7f5.svg";
export { ForwardRef as ReactComponent };